const MAX_VALUES_PER_KEY = 100;
const MAX_VALUE_LENGTH = 200;

function sanitize(values: readonly string[]): string[] {
  const out: string[] = [];
  for (const v of values) {
    if (typeof v !== "string") continue;
    if (!v.length || v.length > MAX_VALUE_LENGTH) continue;
    out.push(v);
    if (out.length >= MAX_VALUES_PER_KEY) break;
  }
  return out;
}

export function useUrlFilterValues() {
  const route = useRoute();
  const router = useRouter();

  function bool(key: string) {
    return computed<boolean>({
      get: () => route.query[key] === "1",
      set: (v) => {
        const query = { ...route.query };
        if (v) query[key] = "1";
        else delete query[key];
        router.push({ query });
      },
    });
  }

  function multi(key: string) {
    let cached: string[] = [];
    return computed(() => {
      const raw = route.query[key];
      let next: string[];
      if (Array.isArray(raw)) {
        next = sanitize(raw.filter((v): v is string => typeof v === "string"));
      } else if (typeof raw === "string" && raw.length) {
        next = sanitize(raw.split(","));
      } else {
        next = [];
      }
      if (next.length === cached.length && next.every((v, i) => v === cached[i])) {
        return cached;
      }
      cached = next;
      return next;
    });
  }

  return { bool, multi };
}
